export default "__VITE_ASSET__DnsipJsN__"